/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Template_Audience_Default_NoteInputs */



/**
* | output |
* | --- |
* | "A default always applies to the whole organisation." |
*
* @param {Settings_Template_Audience_Default_NoteInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const settings_template_audience_default_note = /** @type {((inputs?: Settings_Template_Audience_Default_NoteInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Template_Audience_Default_NoteInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Een standaard geldt altijd voor de hele organisatie.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Un modèle par défaut s’applique toujours à toute l’organisation.")
	return /** @type {LocalizedString} */ ("A default always applies to the whole organisation.")
});